import {Direction} from '../helpers';
import {ThemeDefinition} from '@volkswagen-onehub/components-core';

// Columns based on Layout of 24 columns
export const DEFAULT_SLIDE_WIDTH = 16; // columns
export const WIDE_SLIDE_WIDTH = 20; // columns
export const NO_PREVIEW_SLIDE_WIDTH = 24; // columns

export const START_AND_END_GAP = 2; // columns - space before first / after last slide (for default and wide slides)
export const SLIDE_GAP = 1; // columns - space between two slides (for default and wide slides)
export const NO_PREVIEW_START_AND_END_GAP = 0; // columns
export const NO_PREVIEW_SLIDE_GAP = 0; // columns

export function getItemColumns(
    isWideSlide?: boolean,
    hideNextSlide?: boolean
): number {
    const gap = hideNextSlide ? NO_PREVIEW_SLIDE_GAP : SLIDE_GAP;
    const slideWidth = !hideNextSlide
        ? isWideSlide
            ? WIDE_SLIDE_WIDTH
            : DEFAULT_SLIDE_WIDTH
        : NO_PREVIEW_SLIDE_WIDTH;

    return slideWidth + gap;
}

export const calcPosition = (
    slide: number,
    numberOfSlides: number,
    hideNextSlide: boolean = false,
    isWideSlide: boolean = false,
    direction: ThemeDefinition['direction'] = Direction.LTR
): number => {
    const warnPosition = (slide: number) =>
        console.warn(`Can not set position, non-existing slide <${slide}>.`);

    const isLast = slide === numberOfSlides - 1;
    const slideWidth = getItemColumns(isWideSlide, hideNextSlide);
    const slideMediaWidth = !hideNextSlide
        ? isWideSlide
            ? WIDE_SLIDE_WIDTH
            : DEFAULT_SLIDE_WIDTH
        : NO_PREVIEW_SLIDE_WIDTH;

    // Discrepancy between first slide and all following slides
    const slideDiscrepancy =
        (24 - slideMediaWidth) / 2 -
        (hideNextSlide ? NO_PREVIEW_START_AND_END_GAP : START_AND_END_GAP);

    let position = 0;

    if (slide >= numberOfSlides) {
        warnPosition(slide);

        return calcPosition(numberOfSlides - 1, numberOfSlides);
    }

    if (slide < 0) {
        warnPosition(slide);

        return calcPosition(0, numberOfSlides);
    }

    if (direction === Direction.RTL) {
        const initialPositionRtl = 100 - 100 / numberOfSlides;

        if (slide === 0) {
            return initialPositionRtl;
        }

        position =
            initialPositionRtl -
            (slide * width(numberOfSlides, slideWidth) -
                width(numberOfSlides, slideDiscrepancy));

        return !isLast
            ? position
            : position + width(numberOfSlides, slideDiscrepancy);
    }

    if (slide === 0) {
        return position;
    }

    position =
        slide * width(numberOfSlides, slideWidth) -
        width(numberOfSlides, slideDiscrepancy);

    position = !isLast
        ? position
        : position - width(numberOfSlides, slideDiscrepancy);

    return -position;
};

export const width = (itemCount: number, columnCount: number = 0) => {
    const fraction = 4.16667; // precomputed from 100 / 24 columns

    return (fraction * columnCount) / itemCount;
};

export const nextItem = (activeItem: number, itemCount: number) =>
    activeItem < itemCount - 1 ? activeItem + 1 : activeItem;

export const prevItem = (activeItem: number) =>
    activeItem > 0 ? activeItem - 1 : activeItem;
